import React, {useState} from "react";
import {
  Breadcrumb,
  PageHeader,
  ListingHeader,
  TablePlus,
  SweetAlert,
  ActionWrapper,
} from "../../../../components";
import {
  Columns,
   storeService,
} from "../../../../services/index.service";
import { Link, useNavigate } from "react-router-dom";
import { modalNotification } from "../../../../utils";

function ListStore(props) {
  const EquipmentOrderData = storeService();

  const breadcrumb = [
    {
      path: "/admin/dashboard",
      name: "Dashboard",
      
    },
    {
      path: "#",
      name: "Promo Code Good Guys Affiliate",
    },
  ];

  function onAction(e, handler){
    e.preventDefault();
    handler()
  }
  const actionFormatter = (options) => {
    return (
      <ActionWrapper>
        {options.map((item, key) => {
          return (
            <li onClick={(e)=>onAction(e, item.handler)} key={key} className="action_list">
              <Link to="#">
                <em className={item.icon} />
                {item.name}
              </Link>
            </li>
          );
        })}
      </ActionWrapper>
    );
  };

  const columns = Columns.storeTableColumn({
    Action: () =>
      actionFormatter([
        {
          name: "Edit",
          icon: "icon ni ni-edit",
          handler: () =>{ EditPromoCode()},
        },
        {
          name: "Delete",
          icon: "icon ni ni-trash",
          handler:()=>{ setIsAlertVisible(true);
            document.body.click()}
        },
      ]),
  });
  const statusActionOption = [
    {
    id: 1,
    name: 'Select Action'
    },
    {
    id: 2,
    name: 'Make Active'
    },
    {
    id: 3,
    name: 'Make Inactive'
    },
    {
    id: 4,
    name: 'Make Delete'
    }
  ]  

  const navigate = useNavigate()
  const AddPromoCode = () => {
    navigate("/admin/store/add");
  }
  const EditPromoCode = () => {
    navigate("/admin/store/edit");
  }
    const [isAlertVisible, setIsAlertVisible] = useState(false);
    const onConfirmAlert = () => {
        setIsAlertVisible(false);
        modalNotification({ type: "success", message: "Store Deleted Successfully", })
        return true;
    };
  return (
    <>
      <div className="nk-block-head nk-block-head-sm">
        <div className="nk-block-between">
          <PageHeader heading="Promo Code Good Guys Affiliate">
            <Breadcrumb breadcrumb={breadcrumb} />
          </PageHeader>
          <ListingHeader
            btnArray={['create', 'csvExport',]}
            btnText="Add Store"
            onHandleShow={AddPromoCode}
          />
        </div>
      </div>
      <TablePlus
        hasLimit
        noOfPage="1"
        sizePerPage="10"
        page="1"
        count="100"
        tableData={EquipmentOrderData}
        tableColumns={columns}
        // tableLoader={isLoading}
        setSizePerPage=""
        selectRow={true}
        isSearch={false} 
        showAction={false}
        statusAction
        statusActionOption={statusActionOption}
      />
      <div className="card mt-3">
        <div className="card-inner">
          <div className="bq-note">
            <div className="bq-note-text">
              <div className="nk-block-head nk-block-head-sm nk-block-between">
                <h5 className="title">Notes:</h5>
              </div>
              <ul className="list list-sm list-checked">
                <li>Promo Code Good Guys Affiliate module will list all stores on this page.</li>
                <li>Admin can Activate / Deactivate / Delete any store. Default Store cannot be Activated / Deactivated / Deleted.</li>
                <li>Admin can export data in XLS or PDF format.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <SweetAlert
        title="Are you sure"
        text="you want to delete this Store"
        show={isAlertVisible}
        icon="warning"
        showCancelButton
        confirmButtonText="Yes"
        cancelButtonText="No"
        setIsAlertVisible={setIsAlertVisible}
        // showLoaderOnConfirm
        // loading={loading}
        onConfirmAlert={onConfirmAlert}
      />
    </>
  );
}

export default ListStore;
